import React from 'react';

const Loader = () => {
  return <div className="c-loader"></div>;
}

export default Loader;